import React, { createContext, useContext, useCallback, useState } from 'react';

// Creamos el contexto
export const NuevaONGContext = createContext({
    refetchONGs: () => { },
    registerRefetchONGs: () => { }
});

export const useONGs = () => {
    const context = useContext(NuevaONGContext);
    console.log("usando context--->", context)
    if (!context) {
        throw new Error('useONGs debe usarse dentro de ONGsProvider');
    }
    return context;
};

// Creamos un proveedor del contexto
export const NuevaONGProvider = ({ children }) => {
    const [nuevaONG, setNuevaONG] = useState(null); // Estado para la nueva ONG creada

    const [ongsRefetch, setOngsRefetch] = useState(() => {}); // Función para refetchear ONGs

    //deep
    const [refetchFn, setRefetchFn] = useState(() => () => { });

    const registerRefetchONGs = useCallback((fn) => {
        setRefetchFn(() => fn);
    }, []);
    
    const value = {
        nuevaONG,
        setNuevaONG,
        setOngsRefetch: (fn) => setOngsRefetch(() => fn),
        ongsRefetch,

        refetchONGs: refetchFn,
        registerRefetchONGs
    };

    return (
        <NuevaONGContext.Provider value={value}>
            {children}
        </NuevaONGContext.Provider>
    );
};